import React from 'react';
import PropTypes from 'prop-types';

const ExportDocumentModalBodyContent = props => (
  <p>
    {props.primaryContent}
    {props.isShowingFormat ? props.additionalData.format.toUpperCase() : ''}
    {props.isShowingEllipsis ? '... ' : ' '}
    <i>{props.secondaryContent}</i>
  </p>
);

ExportDocumentModalBodyContent.propTypes = {
  primaryContent: PropTypes.string,
  additionalData: PropTypes.shape({
    format: PropTypes.string,
  }),
  isShowingFormat: PropTypes.bool,
  isShowingEllipsis: PropTypes.bool,
  secondaryContent: PropTypes.string,
};

ExportDocumentModalBodyContent.defaultProps = {
  primaryContent: '',
  additionalData: {
    format: 'pdf',
  },
  isShowingFormat: false,
  isShowingEllipsis: true,
  secondaryContent: '',
};

export default ExportDocumentModalBodyContent;



// WEBPACK FOOTER //
// ./src-react/Modals/content/ExportDocumentBodyContent.jsx